


<div class="side-menu" *ngIf="isLoggedIn">
  <app-sp-sidenav [isSidebarCollapsed]="isSidebarCollapsed"
                  (sidebarToggle)="onSidebarToggle()">
  </app-sp-sidenav>

</div>

<div class="qds-main-section expandable gap8" [class.expanded]="isExpanded" [ngClass]="{'content-expanded': isSidebarCollapsed }">

  <app-header *ngIf="isLoggedIn" style="width:100%"></app-header>
  <div class="root">
    <router-outlet></router-outlet>
  </div>

</div>

